<nb-card class="alert-dialog">
    <nb-card-header class="header">
        <button class="close-dialog" [disabled]="isUpdating" [ngClass]="isUpdating ? 'disable-button': ''" (click)="closeDialog()">
            <morva-icons class="close-cross" icon="close"></morva-icons>
        </button>
        <div data-testid="confirmation-replacement-header-text" class="header-text">تایید جایگزینی داده</div>
    </nb-card-header>
    <nb-card-body class="alert-container px-0 mx-3">
        <section class="my-1">
            <p class="alert-message mb-2">
                آﯾﺎ با جایگزینی منبع داده قبلی {{oldDataSourceName}}
                با منبع داده جدید {{previewDataSourceInfo?.fileName}} موافق هستید؟ 
            </p>
        </section>
        <section 
            class="warning-messages my-2" 
            *ngIf="dataSourceWarnings?.length > 0">
            <morva-linear-notifiction 
                *ngFor="let warning of dataSourceWarnings" 
                [message]="warning"
                messageType="warning" 
                defaultColor="#808080">
            </morva-linear-notifiction>
        </section>
        <section class="nb-card-footer mt-4">
            <button 
                nbButton 
                class="cancle-button"
                [ngClass]="isUpdating ? 'disable-button': ''" 
                [disabled]="isUpdating" 
                (click)="closeDialog()">
                انصراف
            </button>
            <button 
                nbButton 
                nbSpinnerStatus="primary"
                class="submit-button"
                [nbSpinner]="isUpdating"
                [ngClass]="isUpdating ? 'disable-button': ''"
                [disabled]="isUpdating"
                (click)="onSubmitAlert()">
                تایید
            </button>
        </section>
    </nb-card-body>
</nb-card>